import { baseApi } from "./baseApi";

export const sanctionApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // ✅ Route réelle : GET /sanctions (pas /coach/sanctions)
    getSanctions: builder.query({
      query: ({ search = "", page = 1, perPage = 10, status = "", niveau = "", severity = "", startDate = "", endDate = "" } = {}) => {
        const params = new URLSearchParams();
        if (search)    params.append("search", search);
        if (status)    params.append("status", status);
        if (niveau)    params.append("niveau", niveau);
        if (severity)  params.append("severity", severity);
        if (startDate) params.append("start_date", startDate);
        if (endDate)   params.append("end_date", endDate);
        params.append("page", page);
        params.append("per_page", perPage);
        return `/sanctions?${params.toString()}`;
      },
      providesTags: ["Sanctions"],
    }),

    getCoachStagiaires: builder.query({
      query: ({ search = "", per_page = 100 } = {}) => {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        params.append("per_page", per_page);
        return `/coaches/stagiaires?${params.toString()}`;
      },
      transformResponse: (response) => {
        if (Array.isArray(response?.data)) return response.data;
        if (response?.stagiaires)          return response.stagiaires;
        if (Array.isArray(response))       return response;
        return [];
      },
      providesTags: ["Stagiaires"],
    }),

    // ✅ Route réelle : POST /sanctions
    createSanction: builder.mutation({
      query: (sanctionData) => ({
        url: "/sanctions",
        method: "POST",
        body: sanctionData,
      }),
      invalidatesTags: ["Sanctions"],
    }),

    // ✅ Route réelle : POST /sanctions/{id}
    updateSanction: builder.mutation({
      query: ({ id, ...sanctionData }) => ({
        url: `/sanctions/${id}`,
        method: "POST",
        body: sanctionData,
      }),
      invalidatesTags: ["Sanctions"],
    }),

    // ✅ Route réelle : DELETE /sanctions/{id}
    deleteSanction: builder.mutation({
      query: (id) => ({
        url: `/sanctions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Sanctions"],
    }),

    // ✅ Bulk delete n'existe plus — simuler avec appels individuels
    bulkDeleteSanctions: builder.mutation({
      async queryFn(ids, _queryApi, _extraOptions, fetchWithBQ) {
        try {
          await Promise.all(ids.map(id => fetchWithBQ({
            url: `/sanctions/${id}`,
            method: "DELETE",
          })));
          return { data: { success: true } };
        } catch (e) {
          return { error: e };
        }
      },
      invalidatesTags: ["Sanctions"],
    }),

    // ✅ Stats calculées depuis GET /sanctions?per_page=1000
    getSanctionStats: builder.query({
      query: () => `/sanctions?per_page=1000`,
      providesTags: ["Sanctions"],
      transformResponse: (response) => {
        const sanctions = response?.data || (Array.isArray(response) ? response : []);
        return {
          total:          sanctions.length,
          avertissements: sanctions.filter(s => s.niveau === "avertissement").length,
          suspensions:    sanctions.filter(s => s.niveau === "suspension").length,
          renvois:        sanctions.filter(s => s.niveau === "exclusion").length,
          non_lues:       sanctions.filter(s => !s.status || s.status === "Non lue").length,
          faible:         sanctions.filter(s => s.severity === "faible").length,
          moyenne:        sanctions.filter(s => s.severity === "moyenne").length,
          elevee:         sanctions.filter(s => s.severity === "élevée").length,
          critique:       sanctions.filter(s => s.severity === "critique").length,
        };
      },
    }),
  }),
});

export const {
  useGetSanctionsQuery,
  useGetCoachStagiairesQuery,
  useCreateSanctionMutation,
  useUpdateSanctionMutation,
  useDeleteSanctionMutation,
  useBulkDeleteSanctionsMutation,
  useGetSanctionStatsQuery,
} = sanctionApi;